export enum SortDirection {
  SORT,
  SORT_ASC,
  SORT_DESC,
}
